import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=4fead098&"
import script from "./Setup.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Setup.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Setup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports